import { Flex, Text } from "@mantine/core";
import { IconView } from "../../assets/icon/metric/IconView";
import { IconLike } from "../../assets/icon/metric/IconLike";
import { IconReply } from "../../assets/icon/metric/IconReply";
import { IconRepost } from "../../assets/icon/metric/IconRepost";
import { useIsMobile } from "../../hooks/useIsMobile";
import numbro from "numbro";

const MetricStatus = ({ type, value, w, size = "sm" }) => {
	const isMobile = useIsMobile("sm");
	// Truncate the value to prevent overrating

	const formattedValue =
		value > 1000
			? numbro(value).format({
					average: true,
					mantissa: 1,
					optionalMantissa: true,
					roundingFunction: Math.floor,
				})
			: value;

	const iconSize = size === "sm" ? 14 : 20;
	const textSize =
		size === "sm" ? (isMobile ? "sm" : "md") : isMobile ? "md" : "lg";

	return (
		<Flex gap={4} align={"center"} w={w}>
			{type === "view" && <IconView size={iconSize} />}
			{type === "like" && <IconLike size={iconSize} />}
			{type === "reply" && <IconReply size={iconSize} />}
			{type === "repost" && <IconRepost size={iconSize} />}
			<Text size={textSize} fw={500}>
				{formattedValue}
			</Text>
		</Flex>
	);
};

export default MetricStatus;
